<template>
  <div>
    <v-app id="inspire">
      <v-navigation-drawer dark v-model="drawer" width="290" app fixed style="background-color: #000000; display:flex; flex-direction: column; justify-content: space-between;">
        <div style="height: 100%; display: flex; flex-direction: column; justify-content: space-between;">
          <div>
            <v-list-item :to="'/dashboard'" link style="display: flex; justify-content: center;">
              <v-img style="max-width: 80%"  :src="require('../assets/logos/Logotipo_Negativo.png')"></v-img>
            </v-list-item>
            <v-divider style=""></v-divider>
            <v-list class="mx-5">
              <v-list-group prepend-icon="mdi-cog" no-action active-class="activeItem">
                 <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title>General</v-list-item-title>
                  </v-list-item-content>
                </template>
                <v-list-item
                  link
                  disabled
                  active-class="activeItem"
                  to="/dashboardGeneral"
                >
                  <v-list-item-content>
                    <v-list-item-title style="margin-left: 8px; word-wrap: normal;">
                      {{ "Dashboard" }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item
                  link
                  active-class="activeItem"
                  to="/users"
                >
                  <v-list-item-content>
                    <v-list-item-title style="margin-left: 8px; word-wrap: normal;">
                      {{ "Usuarios" }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item
                  link
                  active-class="activeItem"
                  to="/customerEnterprises"
                >
                  <v-list-item-content>
                    <v-list-item-title style="margin-left: 8px; word-wrap: normal;">
                      {{ "Empresas" }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item
                  link
                  active-class="activeItem"
                  to="/tours"
                >
                  <v-list-item-content>
                    <v-list-item-title style="margin-left: 8px; word-wrap: normal;">
                      {{ "Tours" }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-group>
              <v-list-group v-if="availableIds.includes('26e2b08e-45d1-4b28-bde3-9f64c42e493b')" prepend-icon="mdi-shield-check" no-action active-class="activeGroup">
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title>Compliance</v-list-item-title>
                  </v-list-item-content>
                </template>
                <v-list-item v-for="item in currencyCompliance" :key="item.value" v-if="availableIds.includes(item.id)" active-class="activeItem" :to="item.path" link>
                  <v-list-item-content>
                    <v-list-item-title style="margin-left: 8px; word-wrap: normal;">{{ item.title }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-group>
              <v-list-group prepend-icon="mdi-cash" no-action active-class="activeGroup">
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title>Divisas</v-list-item-title>
                  </v-list-item-content>
                </template>
                <v-list-item
                  link
                  active-class="activeItem"
                  to="/dashboard"
                  >
                  <v-list-item-content>
                    <v-list-item-title style="margin-left: 8px; word-wrap: normal;">
                      {{ "Dashboard" }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item
                  link
                  active-class="activeItem"
                  to="/enterprises"
                >
                  <v-list-item-content>
                    <v-list-item-title style="margin-left: 8px; word-wrap: normal;">
                      {{ "Clientes" }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item
                  link
                  active-class="activeItem"
                  to="/calculator"
                >
                  <v-list-item-content>
                    <v-list-item-title style="margin-left: 8px; word-wrap: normal;">
                      Calculadora de Precios
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-group append-icon="mdi-chevron-down" sub-group no-action active-class="activeItem">
                  <template v-slot:activator>
                    <v-list-item-content>
                      <v-list-item-title style="margin-left: 8px">Operaciones</v-list-item-title>
                    </v-list-item-content>
                  </template>
                  <v-list-item v-for="item in currencyOperations" :key="item.value" v-if="availableIds.includes(item.id)" active-class="activeItem" :to="item.path" link>
                    <v-list-item-content>
                      <v-list-item-title style="color: white; text-wrap: wrap;">{{ item.title }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-group>
              </v-list-group>
              <v-list-group v-if="availableIds.includes('3edeba2c-3500-4a47-b563-83e0e7407e8e')" prepend-icon="mdi-account-cash" no-action active-class="activeItem">
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title>Factoraje</v-list-item-title>
                  </v-list-item-content>
                </template>
                <v-list-item
                  link
                  active-class="activeItem"
                  to="/dashboard-factoraje"
                  >
                  <v-list-item-content>
                    <v-list-item-title style="margin-left: 8px; word-wrap: normal;">
                      {{ "Dashboard" }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item
                  link
                  active-class="activeItem"
                  to="/clientes"
                  >
                  <v-list-item-content>
                    <v-list-item-title style="margin-left: 8px; word-wrap: normal;">
                      {{ "Clientes" }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item
                  link
                  active-class="activeItem"
                  to="/invoices"
                  >
                  <v-list-item-content>
                    <v-list-item-title style="margin-left: 8px; word-wrap: normal;">
                      {{ "Invoices" }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item
                  link
                  active-class="activeItem"
                  to="/payment-history"
                  >
                  <v-list-item-content>
                    <v-list-item-title style="margin-left: 8px; word-wrap: normal;">
                      {{ "Pagos" }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item
                  link
                  active-class="activeItem"
                  to="/collection-history"
                  >
                  <v-list-item-content>
                    <v-list-item-title style="margin-left: 8px; word-wrap: normal;">
                      {{ "Cobros" }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item
                  link
                  active-class="activeItem"
                  to="/lista-recargos"
                  >
                  <v-list-item-content>
                    <v-list-item-title style="margin-left: 8px; word-wrap: normal;">
                      {{ "Recargos" }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-group>
              <v-list-group v-if="availableIds.includes('07438fe6-fc56-405a-8f1a-20905d5e0438')" prepend-icon="mdi-account-cash" no-action active-class="activeItem">
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title>Credito Revolvente</v-list-item-title>
                  </v-list-item-content>
                </template>
                <v-list-item
                  link
                  active-class="activeItem"
                  to="/credit/dashboard"
                >
                  <v-list-item-content>
                    <v-list-item-title style="margin-left: 8px; word-wrap: normal;">
                      {{ "Dashboard" }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item
                  link
                  active-class="activeItem"
                  to="/credit/credit-lines"
                >
                  <v-list-item-content>
                    <v-list-item-title style="margin-left: 8px; word-wrap: normal;">
                      {{ "Líneas de crédito" }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item
                  link
                  active-class="activeItem"
                  to="/credit/invoices"
                >
                  <v-list-item-content>
                    <v-list-item-title style="margin-left: 8px; word-wrap: normal;">
                      {{ "Facturas" }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item
                  link
                  active-class="activeItem"
                  to="/credit/draws"
                >
                  <v-list-item-content>
                    <v-list-item-title style="margin-left: 8px; word-wrap: normal;">
                      {{ "Disposiciones" }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-item
                  link
                  active-class="activeItem"
                  to="/credit/payment-history"
                >
                  <v-list-item-content>
                    <v-list-item-title style="margin-left: 8px; word-wrap: normal;">
                      {{ "Cobros" }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-group>
              <v-list-group v-if="availableIds.includes('bfb8d435-5b0b-4ecf-b4bc-70a7c7b31422')" prepend-icon="mdi-robot" no-action active-class="activeItem">
                <template v-slot:activator>
                  <div class="d-flex align-center">
                    <span class="white--text" style="font-family: 'montserrat-semibold'; padding-right: 17px;">Agentes de IA</span>
                  </div>
                </template>
                <v-list-item
                  link
                  disabled
                  active-class="activeItem"
                  to="/invoices"
                >
                  <v-list-item-content>
                    <v-list-item-title style="margin-left: 8px; word-wrap: normal;">
                      {{ "Clientes" }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
                <v-list-group append-icon="mdi-chevron-down" sub-group no-action active-class="activeItem">
                  <template v-slot:activator>
                    <v-list-item-content>
                      <v-list-item-title style="margin-left: 8px">Seguridad</v-list-item-title>
                    </v-list-item-content>
                  </template>
                  <v-list-item
                    link
                    active-class="activeItem"
                    to="/historyReports"
                  >
                    <v-list-item-content>
                      <v-list-item-title style="margin-left: 8px; word-wrap: normal;">
                        {{ "Historial" }}
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <!-- <v-list-item v-for="item in currencyCompliance" :key="item.value" v-if="availableIds.includes(item.id)" active-class="activeItem" :to="item.path" link>
                    <v-list-item-content>
                      <v-list-item-title style="color: white;">{{ item.title }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item> -->
                </v-list-group>
                <v-list-group append-icon="mdi-chevron-down" sub-group no-action active-class="activeItem">
                  <template v-slot:activator>
                    <v-list-item-content>
                      <v-list-item-title style="margin-left: 8px">Marketing</v-list-item-title>
                    </v-list-item-content>
                  </template>
                  <!-- <v-list-item v-for="item in currencyCompliance" :key="item.value" v-if="availableIds.includes(item.id)" active-class="activeItem" :to="item.path" link>
                    <v-list-item-content>
                      <v-list-item-title style="color: white;">{{ item.title }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item> -->
                </v-list-group>
                <v-list-group append-icon="mdi-chevron-down" sub-group no-action active-class="activeItem">
                  <template v-slot:activator>
                    <v-list-item-content>
                      <v-list-item-title style="margin-left: 8px">Ventas</v-list-item-title>
                    </v-list-item-content>
                  </template>
                  <!-- <v-list-item v-for="item in currencyCompliance" :key="item.value" v-if="availableIds.includes(item.id)" active-class="activeItem" :to="item.path" link>
                    <v-list-item-content>
                      <v-list-item-title style="color: white;">{{ item.title }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item> -->
                </v-list-group>
              </v-list-group>
              <v-list-item
                link
                active-class="activeItem"
                to="/settings"
              >
                <v-list-item-icon>
                  <v-icon>mdi-cog-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Configuración</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
            <v-divider></v-divider>
          </div>
          <div>
            <v-divider></v-divider>
            <div class="">
              <v-btn text class="button-session mon-regular px-0" @click="logout" style="font-family: 'montserrat-semibold'; justify-content: center;">
                <v-icon class="mr-2">
                  mdi-logout
                </v-icon>
                {{ "Cerrar sesión" }}
              </v-btn>
              <h5 style="font-family: 'montserrat-regular'; color: #FFFFFF; font-size: 14px; text-align: center; font-weight: 500;" >{{ "Versión " }} {{ appVersion }} | {{ currentYear }} © FRESHER</h5>   
              <h5 class="pb-3" style="font-family: 'montserrat-regular'; color: #FFFFFF; font-size: 14px; text-align: center; font-weight: 500;" >{{ "Todos los derechos reservados" }}</h5> 
            </div>
          </div>
        </div>
      </v-navigation-drawer>
      <v-app-bar color="#ffffff" absolute app height="83" persistent>
        <v-btn
          icon
          dark
          class="d-lg-none d-block"
          @click="drawer = true"
        >
          <v-icon
            size="18px"
            color="#000000"
          >
            mdi-menu
          </v-icon>
        </v-btn>
        <v-toolbar-title
          style="
            font-size: 0.875rem;
            line-height: 1.25rem;
            font-weight: 600;
            display: flex;
            align-items: center;
          "
          class="pa-0"
          >
          <v-list>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-subtitle>
                  {{ currentDateCdmx }} Ciudad de México, GMT-6
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          </v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-icon dark large color="grey">
          mdi-account-circle
        </v-icon>
        <v-list width="170px">
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>{{ userName }}</v-list-item-title>
              <v-list-item-subtitle>{{ "Administrador" }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-app-bar>
      <v-main style="background-color: #F9FAFD;">
        <router-view></router-view>
      </v-main>
    </v-app>
  </div>
</template>

<script>
import moment from "moment";

export default {
  name: "DashboardView",
  data() {
    return {
      loading: true,
      currentDate: moment(),
      currentDateCdmx: moment().clone().utcOffset("-06:00"),
      drawer: null,
      balance: "0",
      appVersion: "1.0.00",
      currentYear: moment().format("YYYY"),
      items: [],
      userName: "",
      availableIds: [],
      tab: 0,
      editableData: {},
      selectedMenuItem: "",
      contactData: {
        sName: "",
        sEmail: "",
        sBank_name: "",
        sAccount_number: "",
        sEntity_business: "COMPANY"
      },
      showCreateProvider: false,
      isResponsive: false,
      screenWidth: 0,
      timerCount: 30,
      factoringClients: [
        { id: '3edeba2c-3500-4a47-b563-83e0e7407e8e',  icon: "mdi-file-document", value: "Clients", title: "Clientes", path: "/clientes", disabled: false },
        { id: '3edeba2c-3500-4a47-b563-83e0e7407e8e',  icon: "mdi-file-document", value: "Lista de cedentes", title: "Lista de cedentes", path: "/lista-cedentes", disabled: false },
        { id: '3edeba2c-3500-4a47-b563-83e0e7407e8e',  icon: "mdi-file-document", value: "Lista de deudores", title: "Lista de deudores2", path: "/lista-deudores", disabled: false },
      ],
      factoringHistory: [
        { id: '3edeba2c-3500-4a47-b563-83e0e7407e8e',  icon: "mdi-file-document", value: "Historial de pagos", title: "Pagos", path: "/payment-history", disabled: false },
        { id: '3edeba2c-3500-4a47-b563-83e0e7407e8e',  icon: "mdi-file-document", value: "Historial de cobros", title: "Cobros", path: "/collection-history", disabled: false }
      ],
      currencyCompliance: [
        { id: '2914c546-1241-4bb1-9b98-2f056f5eb81c', icon: "mdi-file-document", value: "Empresas", title: "Empresas", path: "/compliance", disabled: false },
        { id: '2914c546-1241-4bb1-9b98-2f056f5eb81c', icon: "mdi-file-document", value: "Documentos", title: "Documentos", path: "/complianceDocuments", disabled: false }
      ],
      currencyOperations: [
        { id: '2914c546-1241-4bb1-9b98-2f056f5eb81c', icon: "mdi-file-document", value: "Facturas por Pagar", title: "Facturas por Pagar", path: "/invoicesUSD", disabled: false },
        { id: '2914c546-1241-4bb1-9b98-2f056f5eb81c', icon: "mdi-file-document", value: "Facturas por Cobrar", title: "Facturas por Cobrar", path: "/invoicesMXN", disabled: false },
        { id: '2914c546-1241-4bb1-9b98-2f056f5eb81c', icon: "mdi-file-document", value: "Ingresos", title: "Ingresos", path: "/incomesHistory", disabled: false },
        { id: '2914c546-1241-4bb1-9b98-2f056f5eb81c', icon: "mdi-file-document", value: "Conversiones", title: "Conversiones", path: "/conversionHistory", disabled: false },
        { id: '2914c546-1241-4bb1-9b98-2f056f5eb81c', icon: "mdi-file-document", value: "Conversiones Activas", title: "Conversiones Activas", path: "/conversionActive", disabled: false },
        { id: '2914c546-1241-4bb1-9b98-2f056f5eb81c', icon: "mdi-file-document", value: "Pagos", title: "Pagos", path: "/paymentsHistory", disabled: false },
      ],
      sections: [
        { 
          icon: "mdi mdi-view-dashboard", value: "Empresas", title: "Operaciones",
          items: [
            { id: '2914c546-1241-4bb1-9b98-2f056f5eb81c', icon: "mdi mdi-view-dashboard", value: "Dashboard", title: "Dashboard", path: "/dashboard", disabled: false },
            { id: '2914c546-1241-4bb1-9b98-2f056f5eb81c', icon: "mdi mdi-view-dashboard", value: "Empresas", title: "Empresas", path: "/enterprises", disabled: false },
          ]
        },
        { 
          icon: "mdi-file-document-multiple", value: "Compliance", title: "Compliance",
          items: [
            { id: '2914c546-1241-4bb1-9b98-2f056f5eb81c', icon: "mdi-file-document", value: "Empresas", title: "Empresas", path: "/compliance", disabled: false },
            { id: '2914c546-1241-4bb1-9b98-2f056f5eb81c', icon: "mdi-file-document", value: "Documentos", title: "Documentos", path: "/complianceDocuments", disabled: false }
          ]
        },
        { 
          icon: "mdi-history", value: "Conversiones", title: "Conversiones",
          items: [
            { id: '2914c546-1241-4bb1-9b98-2f056f5eb81c', icon: "mdi-file-document", value: "Conversiones", title: "Historial conversiones ", path: "/conversionHistory", disabled: false },
            { id: '2914c546-1241-4bb1-9b98-2f056f5eb81c', icon: "mdi-file-document", value: "Conversiones Activas", title: "Historial de forwards activos", path: "/conversionActive", disabled: false }
          ]
        },
        {
          icon: "mdi-file-document", value: "Facturas", title: "Facturas",
          items: [
            { id: '2914c546-1241-4bb1-9b98-2f056f5eb81c', icon: "mdi-file-document", value: "Facturas por Pagar", title: "Facturas por Pagar", path: "/invoicesUSD", disabled: false },
            { id: '2914c546-1241-4bb1-9b98-2f056f5eb81c', icon: "mdi-file-document", value: "Facturas por Cobrar", title: "Facturas por Cobrar", path: "/invoicesMXN", disabled: false }
          ]
        },
        { 
          icon: "mdi-history", value: "Historial", title: "Historial",
          items: [
            { id: '2914c546-1241-4bb1-9b98-2f056f5eb81c', icon: "mdi-file-document", value: "Historial de ingresos", title: "Historial de ingresos", path: "/incomesHistory", disabled: false },
            { id: '2914c546-1241-4bb1-9b98-2f056f5eb81c', icon: "mdi-file-document", value: "Historial de pagos", title: "Historial de pagos", path: "/paymentsHistory", disabled: false },
          ]
        },
        { 
          icon: "mdi-history", value: "Factoraje Tradicional", title: "Factoraje Tradicional",
          items: [
            { id: '3edeba2c-3500-4a47-b563-83e0e7407e8e',  icon: "mdi-file-document", value: "Dashboard Factoraje", title: "Dashboard Factoraje", path: "/dashboard-factoraje", disabled: false },
            { id: '3edeba2c-3500-4a47-b563-83e0e7407e8e',  icon: "mdi-file-document", value: "Clients", title: "Clientes", path: "/clientes", disabled: false },
            { id: '3edeba2c-3500-4a47-b563-83e0e7407e8e',  icon: "mdi-file-document", value: "Invoices", title: "Lista de deudores", path: "/invoices", disabled: false },
            { id: '3edeba2c-3500-4a47-b563-83e0e7407e8e',  icon: "mdi-file-document", value: "Lista de recargos", title: "Lista de recargos", path: "/lista-recargos", disabled: false },
            { id: '3edeba2c-3500-4a47-b563-83e0e7407e8e',  icon: "mdi-file-document", value: "Lista de cedentes", title: "Lista de cedentes", path: "/lista-cedentes", disabled: false },
            { id: '3edeba2c-3500-4a47-b563-83e0e7407e8e',  icon: "mdi-file-document", value: "Lista de deudores", title: "Lista de deudores2", path: "/lista-deudores", disabled: false },
            { id: '3edeba2c-3500-4a47-b563-83e0e7407e8e',  icon: "mdi-file-document", value: "Historial de pagos", title: "Dashboard Factoraje2", path: "/payment-history", disabled: false },
            { id: '3edeba2c-3500-4a47-b563-83e0e7407e8e',  icon: "mdi-file-document", value: "Historial de cobros", title: "Dashboard Factoraje3", path: "/collection-history", disabled: false },
            { id: '3edeba2c-3500-4a47-b563-83e0e7407e8e',  icon: "mdi-file-document", value: "Calendario", title: "Calendario", path: "/calendario", disabled: false },
          ]
        },
        // { 
        //   icon: "mdi-history", value: "Factoraje Tradicional", title: "Factoraje Flete",
        //   items: [
        //     { icon: "mdi-file-document", value: "Dashboard Factoraje", title: "Dashboard Factoraje", path: "/dashboard-flete", disabled: false },
        //     { icon: "mdi-file-document", value: "Lista de clientes", title: "Lista de cedentes", path: "/lista-cedentes-flete", disabled: false },
        //     { icon: "mdi-file-document", value: "Lista de fleteros", title: "Lista de deudores", path: "/lista-deudores-flete", disabled: false },
        //     { icon: "mdi-file-document", value: "Calendario", title: "Calendario", path: "/calendario-flete", disabled: false },
        //   ]
        // },
      ],
    };
  },
  computed: {
    filteredSections() {
      return this.sections
        .map(section => {
          const filteredItems = section.items.filter(item => this.availableIds.includes(item.id));
          if (filteredItems.length > 0) {
            return { ...section, items: filteredItems };
          }
          return null;
        })
        .filter(section => section !== null);
    }
  },
  created() {
  },
  methods: {
    updateTime() {
      this.currentDate = moment();
      this.currentDateCdmx = moment().utcOffset("-06:00")
    },
    logout() {
      if (this.$store.state.sToken !== "") {
        const config = {
          headers: {
            Authorization: `Bearer ${this.$store.state.sToken}`,
          },
        };

        DB.delete(`${URI}/api/v1/en/session`, config)
          .then((response) => {
            const self = this;

            localStorage.clear();
            this.$store.commit("setIsLogged", false);
            this.$store.commit("setFadeMenu", false);
            this.$store.commit("setToken", "");
            this.$store.commit("setFullName", "");
            this.$store.commit("setEnterpriseId", "");
            this.$store.commit("setUserId", "");
            this.$store.commit("setPermissions", []);

            setTimeout(function() {
              self.mixSuccess(response.data.message);
            }, 200);
            setTimeout(function() {
              self.$router
                .push({
                  path: "/login",
                })
                .catch(() => {});
            }, 400);
          })
          .catch((error) => {
            this.mixError(error.response.data.message, error.response.status);
          });
      }
    },
    changeLanguage(language) {
      const config = {
          headers: {
            Authorization: `Bearer ${this.$store.state.sToken}`,
          },
        },
        payload = {};

      if (this.$store.state.sUserId) {
        DB.patch(
          `${URI}/api/v1/${language}/users/${this.$store.state.sUserId}/languages`,
          payload,
          config
        )
          .then((response) => {
            // Manejo de respuesta exitosa
          })
          .catch((error) => {
            this.mixError(error.response.data.message, error.response.status);
          });
      }
      this.$store.commit("toggle_language", language);
    },
  },
  beforeMount() {
    this.interval = setInterval(this.updateTime, 1000); // 1000 ms = 1 segundo
    this.availableIds = this.$store.state.sModules.map(mod => mod.sModuleId);
  },
  mounted() {
    this.currentTime = this.currentDate.format("MMMM DD, YYYY, HH:mm:ss [GMT]Z");
    this.currentTimeCdmx = this.currentDateCdmx.format("MMMM DD, YYYY, HH:mm:ss [GMT-6]");
  },
  beforeDestroy() {
  },
};
</script>

<style>
/* .v-list-item--active {
  color: yellow !important;
  background-color: yellow !important;
} */

.custom-bold {
  font-family: "montserrat-bold";
  font-weight: bold;
  font-size: medium;
  color: #000;
}


.v-dialog {
  border-radius: 25px !important;
}
.active-section .v-list-item__title {
  background-color: yellow !important;
}

.active-item {
  background-color: #f5f7f9 !important;
}

.v-list-item__content {
  font-family: 'montserrat-semibold';
}

.activeGroup {
  border-radius: 5px;
  color: #FFFFFF !important;
  background-color: #696969;
}
.activeItem {
  border-radius: 5px;
  color: #FFFFFF !important;
  background-color: #808080;
}

.button-select-language {
  width: 100%;
  height: 40px !important;
  background-color: transparent !important;
  border-radius: 10px;
  opacity: 1;
  color: #ffffff !important;
  font-size: 14px !important;
  text-transform: capitalize;
  justify-content: flex-start;
}

.button-select-language-active {
  width: 100%;
  height: 40px !important;
  background: #808080 0% 0% no-repeat padding-box !important;
  border-radius: 10px;
  opacity: 1;
  color: #ffffff !important;
  font-size: 14px !important;
  text-transform: capitalize;
  justify-content: flex-start;
}

.button-session {
  background-color: transparent !important;
  height: 70px !important;
  width: 100% !important;
  border-radius: 0px;
  color: #ffffff !important;
  font-size: 16px;
  text-transform: initial;
  justify-content: flex-start;
  padding-left: 40px !important;
}

.text-wrap {
  white-space: normal;
  word-wrap: break-word;
}
.theme--dark.v-list-item--active:hover::before, .theme--dark.v-list-item--active::before {
  opacity: 0 !important;
}

</style>

